import type { Step } from 'react-joyride';

export const LOGISTICA_HOME_TOUR_ID = 'logistica-home';

type LogisticaHomeTourFlags = {
  hasModuleSwitcher: boolean;
};

export function buildLogisticaHomeTourSteps({ hasModuleSwitcher }: LogisticaHomeTourFlags): Step[] {
  const steps: Step[] = [];

  if (hasModuleSwitcher) {
    steps.push({
      target: '[data-tour="module-switcher"]',
      title: 'Cambia de módulo',
      content: 'Desde aquí puedes moverte entre Tesorería, Membresías y Logística.',
      placement: 'right',
      skipBeacon: true,
    });
  }

  steps.push(
    {
      target: '[data-tour="logistics-home-priorities"]',
      title: 'Qué necesita tu atención',
      content:
        'Pedidos por despachar, ventas por facturar, productos agotados y el estado de caja.',
      placement: 'bottom',
      skipBeacon: !hasModuleSwitcher,
    },
    {
      target: '[data-tour="logistics-home-workspace"]',
      title: 'Proceso comercial',
      content:
        'Sigue el flujo Cotización → Pedido → Despacho → Venta, o crea directamente desde cualquier etapa.',
      placement: 'top',
    },
    {
      target: '[data-tour="logistics-home-tabs"]',
      title: 'Más allá de la venta',
      content: 'Cambia de pestaña para administrar Caja, Inventario o Abastecimiento.',
      placement: 'bottom',
    },
    {
      target: '[data-tour="logistics-home-shortcuts"]',
      title: 'Consulta y análisis',
      content: 'Accesos directos a operaciones, ítems y el resumen ejecutivo del módulo.',
      placement: 'top',
    },
    {
      target: '[data-tour="help-button"]',
      title: '¿Necesitas repasar esto?',
      content: 'Puedes volver a ver esta guía cuando quieras desde este botón.',
      placement: 'left',
    },
  );

  return steps;
}
